module.exports = __webpack_public_path__ + "media/images/icon/button-urgent-no-applications-fb4a92b7bc1e67cfa74a582f1f9704c4.png";